<template>
    <PublicTemplate>
        <section class="pt-5 projects__ProjectsList-n7y0f2-0 ijnbdN">
            <div class="container">
                <h5>Mới nhất</h5>
                <div class="animated fadeInUp" style="animation-duration: 1s;">
                    <ul class="projects_list">
                        <li><a href="/project/maldives-lux-north-male-atoll">
                                <div class="image_wrap"><img src="/uploads/maldives_2_opt_2d65f4ea69.jpg"
                                        alt="project featured"></div>
                                <h5>Khách sạn sang trọng Reefs<span>|</span>Maldives</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/bangkok-ashton-asoke">
                                <div class="image_wrap"><img src="/uploads/bangkok_opt_3_cecc63b636.jpg"
                                        alt="project featured"></div>
                                <h5>ASHTON ASOKE<span>|</span>Bangkok</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/da-nang-the-ocean-suites">
                                <div class="image_wrap"><img src="/uploads/da_nang_opt_1_b4008aafba.jpg"
                                        alt="project featured"></div>
                                <h5>The Ocean Suites<span>|</span>Đà Nẵng</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/sanya-atlantis">
                                <div class="image_wrap"><img src="/uploads/1_7449ec1be9_728733f169.png"
                                        alt="project featured"></div>
                                <h5>Khách sạn Atlantis<span>|</span>Tam Á</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/bangkok-monument-sanampao">
                                <div class="image_wrap"><img src="/uploads/1_7449ec1be9.png" alt="project featured">
                                </div>
                                <h5>MONUMENT SANAMPAO<span>|</span>Bangkok</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/bangkok-ashton-siom">
                                <div class="image_wrap"><img src="/uploads/1_930694fc67.jpg" alt="project featured">
                                </div>
                                <h5>ASHTON SIOM<span>|</span>Bangkok</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/bangkok-the-base-rama-9">
                                <div class="image_wrap"><img src="/uploads/1_0580ca5074.png" alt="project featured">
                                </div>
                                <h5>THE BASE RAMA 9<span>|</span>Bangkok</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/bangkok-whizdom-inspire-hr-1">
                                <div class="image_wrap"><img src="/uploads/1_25af609cda.png" alt="project featured">
                                </div>
                                <h5>WHIZDOM INSPIRE (HR1)<span>|</span>Bangkok</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/bangkok-the-line-pradipat">
                                <div class="image_wrap"><img src="/uploads/1_db00c5639f.png" alt="project featured">
                                </div>
                                <h5>THE LINE PRADIPAT<span>|</span>Bangkok</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/bangkok-amanta">
                                <div class="image_wrap"><img src="/uploads/1_ef0b2fcd53.png" alt="project featured">
                                </div>
                                <h5>AMANTA<span>|</span>Bangkok</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/bangkok-centric-ratchayothin">
                                <div class="image_wrap"><img src="/uploads/1_de064ed71e.png" alt="project featured">
                                </div>
                                <h5>CENTRIC RATCHAOTHIN<span>|</span>Bangkok</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/bangkok-xt-ekkamai">
                                <div class="image_wrap"><img src="/uploads/3_b9df0c4109.png" alt="project featured">
                                </div>
                                <h5>XT EKKAMAI<span>|</span>Bangkok</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/bangkok-oka-haus">
                                <div class="image_wrap"><img src="/uploads/1_a6c838ee95.png" alt="project featured">
                                </div>
                                <h5>OKA HAUS<span>|</span>Bangkok</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/bangkok-beatniq">
                                <div class="image_wrap"><img src="/uploads/2_4f4da9e2ab.jpg" alt="project featured">
                                </div>
                                <h5>BEATNIQ<span>|</span>Bangkok</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/bangkok-the-line-sathorn">
                                <div class="image_wrap"><img
                                        src="/uploads/the_line_sathorn_condo_bangkok_5a3cd434a12eda6ea4007c13_full_13657985d3.jpg"
                                        alt="project featured"></div>
                                <h5>THE LINE SATHORN<span>|</span>Bangkok</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/bangkok-whizdom101">
                                <div class="image_wrap"><img src="/uploads/QQ_20181106092626_73f10b60ec.jpg"
                                        alt="project featured"></div>
                                <h5>Whizdom101<span>|</span>Bangkok</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/vietnam-flc-resort-quy-nhon">
                                <div class="image_wrap"><img src="/uploads/1_5bd61e056e.jpg" alt="project featured">
                                </div>
                                <h5>Khu nghỉ dưỡng FLC Quy Nhơn<span>|</span>Quy Nhơn, Việt Nam</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/da-nang-montgomerie-links">
                                <div class="image_wrap"><img src="/uploads/1_fd8e168575.jpg" alt="project featured">
                                </div>
                                <h5>Montgomerie Links<span>|</span>Đà Nẵng, Việt Nam</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/da-nang-bangkok">
                                <div class="image_wrap"><img src="/uploads/1_dcd157e18f.jpg" alt="project featured">
                                </div>
                                <h5>Đà Nẵng, Việt Nam<span>|</span>Đà Nẵng, Việt Nam</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/australia-busselton-hopspital">
                                <div class="image_wrap"><img src="/uploads/1_b08b5c50d1.jpg" alt="project featured">
                                </div>
                                <h5>Bệnh viện Busselton<span>|</span>Úc</h5>
                                <h4></h4>
                            </a></li>
                        <li><a href="/project/foshan-vanke-crystal-city">
                                <div class="image_wrap"><img src="/uploads/Foshan_Vanke_Crystal_City_1_aa670a35ef.jpg"
                                        alt="project featured"></div>
                                <h5>Khu đô thị Vạn Khoa Thủy Tinh<span>|</span>Phật Sơn</h5>
                                <h4></h4>
                            </a></li>
                    </ul>
                </div>
            </div>
        </section>
    </PublicTemplate>
</template>

<script>
import PublicTemplate from '@/templates/PublicTemplate.vue';
export default {
    name: 'ProjectsView',
    mounted() {

        window.scrollTo(0, 0);
    },
    components: {
        PublicTemplate
    }
}
</script>

<style lang="less">
.hWBHX {
    background: var(--brand_black);
    opacity: 0;
    -webkit-transition: var(--transition);
    transition: var(--transition);
    overflow: hidden;
}

/*!sc*/
.hWBHX.fade_in {
    opacity: 1;
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper {
    padding-top: 40px;
    padding-bottom: 40px;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper {
        padding-top: 50px;
        padding-bottom: 15px;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    -webkit-column-gap: 90px;
    column-gap: 90px;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid {
        grid-template-columns: 1fr;
    }
}

/*!sc*/
@media (max-width:480px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid {
        text-align: center;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 {
    margin-bottom: 55px;
    color: white;
    text-align: left;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 {
        margin-bottom: 30px;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 svg {
    height: 34px;
    margin-right: 15px;
    fill: white;
    padding-top: 6px;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 svg {
        height: 26px;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .content_wrap {
    margin-bottom: 35px;
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .content_wrap p {
    color: #fff;
    text-align: left;
    margin-bottom: 15px;
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper {
    display: block;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper {
        padding-bottom: 60px;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper {
    place-items: left;
    display: block;
    text-align: left;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper {
        place-items: center;
        text-align: center;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper a {
    color: white;
    border: 1px solid white;
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper a:hover {
    color: var(--brand_black);
    background-color: white;
    -webkit-transform: translateY(-3px);
    -ms-transform: translateY(-3px);
    transform: translateY(-3px);
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_image {
    padding-top: 75%;
    display: block;
    -webkit-text-decoration: none;
    text-decoration: none;
    overflow: hidden;
    position: relative;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_image {
        display: none;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_image img {
    height: 100%;
    display: block;
    position: absolute;
    object-fit: cover;
    object-position: center;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

/*!sc*/
data-styled.g5[id="LearnHow__LearnHowWrap-bgqo87-0"] {
    content: "hWBHX,"
}

/*!sc*/
.hwsgMr {
    width: 100%;
    position: relative;
    overflow: hidden;
    background-color: var(--brand_black);
    opacity: 0;
    display: block;
    -webkit-transition: var(--transition);
    transition: var(--transition);
    margin-top: 140px;
}

/*!sc*/
@media (max-width:1024px) {
    .hwsgMr {
        margin-top: 50px;
    }
}

/*!sc*/
.hwsgMr.fade_in {
    opacity: 1;
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
.hwsgMr:before {
    content: ' ';
    display: block;
    background-color: black;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.3;
    z-index: 1;
}

/*!sc*/
.hwsgMr .glide .glide__track .glide__slide {
    height: 70vh;
    min-height: 600px;
    position: relative;
    width: 100%;
    overflow: hidden;
}

/*!sc*/
@media (max-width:1024px) {
    .hwsgMr .glide .glide__track .glide__slide {
        height: 600px;
        min-height: 300px;
    }
}

/*!sc*/
@media (max-width:768px) {
    .hwsgMr .glide .glide__track .glide__slide {
        height: 300px;
        min-height: 300px;
    }
}

/*!sc*/
.hwsgMr .glide .glide__track .glide__slide:before {
    content: ' ';
    display: block;
    background-color: black;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.3;
    z-index: 1;
}

/*!sc*/
.hwsgMr .glide .glide__track .glide__slide img {
    display: block;
    position: absolute;
    object-fit: cover;
    min-width: 100%;
}

/*!sc*/
@media (max-width:1024px) {
    .hwsgMr .glide .glide__track .glide__slide img {
        height: 100%;
        width: auto;
    }
}

/*!sc*/
.hwsgMr .video_wrapper,
.hwsgMr .image_wrapper {
    position: relative;
}

/*!sc*/
@media (max-width:768px) {}

/*!sc*/
.hwsgMr .video_wrapper:before,
.hwsgMr .image_wrapper:before {
    content: ' ';
    display: block;
    background-color: black;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.3;
    z-index: 1;
}

/*!sc*/
.hwsgMr .video_wrapper video,
.hwsgMr .image_wrapper video,
.hwsgMr .video_wrapper>img,
.hwsgMr .image_wrapper>img {
    display: block;
    width: 100%;
}

/*!sc*/
@media (max-width:1024px) {}

/*!sc*/
.hwsgMr video,
.hwsgMr>img {
    display: block;
    min-width: 100%;
}

/*!sc*/
.hwsgMr .hero_headings {
    position: absolute;
    z-index: 2;
    text-align: center;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    color: white;
}

/*!sc*/
@media (max-width:1024px) {
    .hwsgMr .hero_headings {
        width: 100%;
        top: 50%;
    }
}

/*!sc*/
.hwsgMr .hero_headings h2 {
    font-size: 1.7em;
    color: white;
    font-weight: 400;
    margin-bottom: 30px;
    -webkit-letter-spacing: 1.5px;
    -moz-letter-spacing: 1.5px;
    -ms-letter-spacing: 1.5px;
    letter-spacing: 1.5px;
}

/*!sc*/
@media (max-width:1024px) {
    .hwsgMr .hero_headings h2 {
        margin-bottom: 5px;
        font-size: 1.3em;
    }
}

/*!sc*/
.hwsgMr .hero_headings h3 {
    -webkit-text-decoration: none;
    text-decoration: none;
    color: #d8d8d8;
    -webkit-letter-spacing: 1.5px;
    -moz-letter-spacing: 1.5px;
    -ms-letter-spacing: 1.5px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    font-size: 0.6em;
    padding: 12px 18px;
    font-weight: 300;
}

/*!sc*/
.hwsgMr .hero_headings .hero-input {
    height: 40px;
    width: 100%;
    font-size: 15px;
}

/*!sc*/
@media (max-width:1024px) {
    .hwsgMr .hero_headings .hero-input {
        height: 35px;
        font-size: 14px;
        margin-top: 16px;
    }
}

/*!sc*/
.hwsgMr .hero_headings .hero-input input {
    width: 100%;
    height: 100%;
    display: block;
    background-color: white;
    border: 0;
    outline: 0;
    padding: 16px;
    margin: 0 auto;
}

/*!sc*/
@media (max-width:1024px) {
    .hwsgMr .hero_headings .hero-input input {
        width: 45%;
    }
}

/*!sc*/
@media (max-width:768px) {
    .hwsgMr .hero_headings .hero-input input {
        width: 90%;
    }
}

/*!sc*/
@media (max-width:480px) {
    .hwsgMr .hero_headings .hero-input input {
        width: 90%;
    }
}

/*!sc*/
data-styled.g23[id="HeroSingle__HeroPage-w7ry9g-0"] {
    content: "hwsgMr,"
}

/*!sc*/
.ijnbdN {
    position: relative;
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
.ijnbdN .container {
    overflow: hidden;
    padding-top: 40px;
}

/*!sc*/
.ijnbdN .container>h4 {
    text-align: center;
    font-size: 0.87em;
    color: var(--text_grey);
    font-weight: 300;
    text-transform: uppercase;
    margin-bottom: 50px;
    -webkit-letter-spacing: 1px;
    -moz-letter-spacing: 1px;
    -ms-letter-spacing: 1px;
    letter-spacing: 1px;
}

/*!sc*/
@media (max-width:1024px) {
    .ijnbdN .container>h4 {
        margin-bottom: 30px;
    }
}

/*!sc*/
.ijnbdN .container>h3 {
    text-align: center;
    font-size: 1.8em;
    font-weight: 300;
    color: var(--brand_black);
    margin-bottom: 115px;
    -webkit-letter-spacing: 0.5px;
    -moz-letter-spacing: 0.5px;
    -ms-letter-spacing: 0.5px;
    letter-spacing: 0.5px;
}

/*!sc*/
@media (max-width:1024px) {
    .ijnbdN .container>h3 {
        margin-bottom: 60px;
    }
}

/*!sc*/
.ijnbdN .container>h5 {
    font-size: 0.6em;
    line-height: 1.1;
    color: var(--text_grey);
    text-transform: uppercase;
    font-weight: 500;
    margin: 0;
    margin-bottom: 40px;
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 30px;
}

/*!sc*/
.ijnbdN .container>h5:before {
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    align-self: center;
    content: ' ';
    display: block;
    width: 30px;
    height: 2px;
    background-color: var(--text_grey_light);
    opacity: 0.1;
}

/*!sc*/
data-styled.g207[id="projects__ProjectsList-n7y0f2-0"] {
    content: "ijnbdN,"
}

/*!sc*/
</style>